import React from "react";

function formatRelativeTime(timestamp) {
  if (!timestamp) return "";
  const now = new Date();
  const date = new Date(timestamp);
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 1) return "Just now";
  if (diffMins < 60) return `${diffMins}m ago`;

  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours}h ago`;

  const diffDays = Math.floor(diffHours / 24);
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) return `${diffDays}d ago`;

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
}

export default function ChatListItem({ message, isSelected, onSelect, highlightText }) {
  if (!message) return null;

  // Extract phone number and use it as display name
  const phone = message.phone_number || "Unknown";
  const initials = phone.slice(-2).toUpperCase();

  // Highlight helper: returns array of React nodes with <mark> for matches
  const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const renderHighlighted = (text = "", query = "") => {
    if (!query) return text;
    const q = query.toString();
    const parts = text.split(new RegExp(`(${escapeRegExp(q)})`, "i"));
    return parts.map((part, i) => {
      if (part.toLowerCase() === q.toLowerCase()) {
        return (
          <mark key={i} className="bg-yellow-200 rounded px-0.5">
            {part}
          </mark>
        );
      }
      return <span key={i}>{part}</span>;
    });
  };

  return (
    <div
      onClick={onSelect}
      className={`flex items-center gap-3 p-4 cursor-pointer transition hover:bg-gray-50 ${
        isSelected ? "bg-blue-50 border-l-4 border-blue-500" : ""
      }`}
    >
      {/* Avatar with initials */}
      <div className="relative flex-shrink-0">
        <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-full flex items-center justify-center text-white font-semibold text-sm">
          {initials}
        </div>
        {/* WA-06: previously a hardcoded-always-green dot with no data behind it. There's no
            other presence concept in this app (WhatsApp's Cloud API doesn't expose customer
            online/offline status to businesses at all), so a static green dot would now directly
            contradict a conversation correctly sitting in the Inactive tab. Wired to the same
            backend-computed conversationStatus the tabs use. */}
        <div
          className={`absolute bottom-0 right-0 w-3 h-3 border-2 border-white rounded-full ${
            message.conversationStatus === "active" ? "bg-green-500" : "bg-gray-400"
          }`}
        />
      </div>

      {/* Chat Info */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-1">
          <p className="font-semibold text-gray-800 truncate">
            {renderHighlighted(phone, highlightText)}
          </p>
          <p className="text-xs text-gray-500">
            {formatRelativeTime(message.timestamp)}
          </p>
        </div>
        <p className="text-sm text-gray-600 truncate">
          {renderHighlighted(message.message_text || "No message", highlightText)}
        </p>
      </div>
    </div>
  );
}